theme.headerSticky = (function() {
  function unwrapExistingGroup(){
    var oldGroup = document.querySelector('.sticky-header-group');
    if(!oldGroup) return;
    while(oldGroup.firstChild){
      oldGroup.parentNode.insertBefore(oldGroup.firstChild, oldGroup);
    }
    oldGroup.remove();
    var oldPlaceholder = document.querySelector('.sticky-header-group__placeholder');
    if(oldPlaceholder) oldPlaceholder.remove();
  }

  function ScrollSticky(headerContainer){
    // Section re-renders in the theme editor swap the header markup back in
    // unwrapped, so clear out any wrapper left from a previous init first.
    unwrapExistingGroup();

    const headerEl = headerContainer || document.getElementById('shopify__header__section');
    const headerBar = headerEl ? headerEl.querySelector('.header__sticky') : null;

    if(!headerEl || !headerBar) return;

    const menuWrapperEl = document.querySelector('.header-menu-sticky-wrapper');
    const menuBar = menuWrapperEl ? menuWrapperEl.querySelector('.header-menu__sticky') : null;

    // Wrap the header bar (and the menu bar below it, when it's also set to
    // stick) in one shared container so they stick and move together as a
    // single unit instead of each being position: fixed independently.
    const group = document.createElement('div');
    group.className = 'sticky-header-group';

    const placeholder = document.createElement('div');
    placeholder.className = 'sticky-header-group__placeholder';

    headerEl.parentNode.insertBefore(group, headerEl);
    group.appendChild(headerEl);
    if(menuWrapperEl && menuBar){
      group.appendChild(menuWrapperEl);
    }
    group.parentNode.insertBefore(placeholder, group.nextSibling);

    const stickyThreshold = group.getBoundingClientRect().height;
    // A few px of hysteresis around the threshold, so a scroll position
    // sitting right at it (trackpad momentum, a small bounce-back) doesn't
    // flicker the sticky class on/off - and with it, replay the slide-down
    // animation over and over, which is what looked like the header
    // "jumping"/getting stuck while scrolling.
    const hysteresis = 20;
    let ticking = false;

    function checkSticky(){
      // A cart/filter/search overlay locks body scroll (overflow: hidden;
      // see global.css: .added__overlay, .added__overlay_search,
      // .added__overlay_filter). That lock can itself trigger a spurious
      // scroll event on some browsers, which used to run the normal
      // sticky/unstick logic below mid-overlay - clearing the placeholder
      // height while the header was still position:fixed, so the page
      // content jumped up underneath it. Skip recalculating entirely while
      // any of those overlays is open; the scroll position hasn't actually
      // moved from the visitor's point of view.
      const bodyClasses = document.body.classList;
      if(
        bodyClasses.contains('added__overlay') ||
        bodyClasses.contains('added__overlay_search') ||
        bodyClasses.contains('added__overlay_filter')
      ) return;

      const isSticky = group.classList.contains('sticky');
      if(!isSticky && window.scrollY > stickyThreshold + hysteresis){
        placeholder.style.height = group.getBoundingClientRect().height + 'px';
        group.classList.add('sticky');
        headerBar.classList.add('sticky');
        if(menuBar) menuBar.classList.add('sticky');
      } else if(isSticky && window.scrollY < stickyThreshold - hysteresis){
        group.classList.remove('sticky');
        headerBar.classList.remove('sticky');
        if(menuBar) menuBar.classList.remove('sticky');
        placeholder.style.height = '';
      }
    }

    function onScroll(){
      if(!ticking){
        window.requestAnimationFrame(function(){
          checkSticky();
          ticking = false;
        });
        ticking = true;
      }
    }

    checkSticky();
    window.addEventListener('scroll', onScroll);
  }
  return ScrollSticky;
})();
